<template>
  <div class="page-content">
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <el-date-picker
                v-model="search.date_range"
                type="daterange"
                size="small"
                :picker-options="date_picker_options"
                @change="dateCheck"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date">
              </el-date-picker> &nbsp;
              <el-select size="small" @input="handleInputStatusFilter" v-model="status_filter" placeholder="Select">
                <el-option
                  v-for="item in statusFilterOptions"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select> &nbsp;
              <el-select v-model="callChannel" size="small" placeholder="Select">
                <el-option v-for="(item, i) in callChannelOptions" :key="i" :value="item.value" :label="item.text" />
              </el-select> &nbsp;
              <el-select v-model="callType" size="small" placeholder="Select">
                <el-option v-for="(item, i) in callTypeOptions" :key="i" :value="item.value" :label="item.text" />
              </el-select> &nbsp;
              <el-button :loading="loading.table" @click="page = 1; getList();" size="small" class="btn-default" icon="el-icon-search">Search</el-button>
              <el-button :loading="loading.table" @click="downloadReport();" size="small" class="btn-primary" icon="el-icon-download">Download</el-button>
            </div>
            <hr/>
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Status</th>
                    <th>Channel</th>
                    <th>Customer Phone</th>
                    <th>Call Date & Time</th>
                    <th>Answered Time</th>
                    <th>Answered Duration</th>
                    <th>End Time</th>
                    <th>Call Duration</th>
                    <th>Call Direction</th>
                    <th>Call Type</th>
                    <th>Agent Name</th>
                    <th>Agent Email</th>
                    <th>Notes</th>
                    <th>Record Call</th>
                    <th>SLA First Response</th>
                    <th>Status SLA First Response</th>
                    <th>SLA Resolution</th>
                    <th>Status SLA Resolution</th>
                  </tr>
                </thead>
                <tbody v-loading="loading.table">
                  <tr v-for="(item, i) in reportList" :key="i">
                    <td>
                      <el-tag size="mini" :type="item.status_color">
                        {{ item.status_str }}
                      </el-tag>
                    </td>
                    <td>
                      {{ ucwords(item.channel_type) }}
                    </td>
                    <td>
                      {{ isChatPrivacy(item.identifier) }}
                    </td>
                    <td>
                      {{ item.calling_at ? formatDate(item.calling_at) : formatDate(item.created_at) }}
                    </td>
                    <td>
                      {{ formatAnsweredTime(item) }}
                    </td>
                    <td>
                      {{ humanizeDuration(item.ring_duration * 1000) }}
                    </td>
                    <td>
                      {{ item.terminated_at ? formatDate(item.terminated_at) : '-' }}
                    </td>
                    <td>
                      {{ formatDuration(item) }}
                    </td>
                    <td>
                      {{ item.type_str }}
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <FeatherIcon :type="item.action_type_str == 'Video call' ? 'video' : 'phone-call'" size="12px" class="mr-1" />
                        {{ item.action_type_str }}
                      </div>
                    </td>
                    <td>
                      {{ item.agent?.name ? item.agent.name : '-' }}
                    </td>
                    <td>
                      {{ item.agent?.name ? item.agent.email : '-' }}
                    </td>
                    <td>
                      <el-popover v-if="item.notes"
                        placement="right"
                        width="400"
                        trigger="hover"
                        :content="item.notes"
                      >
                        <template>
                          <span
                            slot="reference"
                            class="cursor-pointer"
                            style="display: inline-block; max-width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                          >
                            {{ item.notes || '-' }}
                          </span>
                        </template>
                      </el-popover>
                      <span v-else>-</span>
                    </td>
                    <!-- <td>
                      {{ item.agent?.agent_group ? item.agent.agent_group.name : '-' }}
                    </td> -->
                    <td>
                      <a
                        v-if="getRecordingLink(item)"
                        class="btn btn-primary btn-sm"
                        style="font-weight: normal;"
                        :href="getRecordingLink(item)"
                        target="_blank"
                      >
                        Play Record
                      </a>
                      <p v-else>-</p>
                    </td>
                    <td>
                      <template v-if="custom_feature?.sla?.status && item.answered_at && item.direction === 'incoming' && item.status_str === 'Success'">
                        {{ getSlaTimeResponseDeadline(item.channel_type, (item.ringing_at || item.created_at), custom_feature.sla.settings.call.first_time_response) }}
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                    <td>
                      <template v-if="custom_feature?.sla?.status && item.answered_at && item.direction === 'incoming' && item.status_str === 'Success'">
                        <el-tag
                          class="mr-2"
                          size="mini"
                          :type="isOverdueFirstTimeResponse(item, custom_feature.sla.settings.call.first_time_response) ? 'danger' : 'success'"
                        >
                          {{ isOverdueFirstTimeResponse(item, custom_feature.sla.settings.call.first_time_response) ? 'Overdue' : 'OK' }}
                        </el-tag>
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                    <td>
                      <template v-if="custom_feature?.sla?.status && (item.answered_at || item.duration) && item.status_str === 'Success'">
                        {{ getSlaTimeResponseDeadline(item.channel_type, item.answered_at, custom_feature.sla.settings.call.resolution_time, item.terminated_at, item.duration) }}
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                    <td>
                      <template v-if="custom_feature?.sla?.status && (item.answered_at || item.duration) && item.status_str === 'Success'">
                        <el-tag
                          class="mr-2"
                          size="mini"
                          :type="isOverdueResolutionTime(item, custom_feature.sla.settings.call.resolution_time) ? 'danger' : 'success'"
                        >
                          {{ isOverdueResolutionTime(item, custom_feature.sla.settings.call.resolution_time) ? 'Overdue' : 'OK' }}
                        </el-tag>
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
              <el-empty v-if="totalRow == 0" description="No data"></el-empty>
            </div>
            <b-pagination v-if="totalRow > page_limit" v-model="currentPage" :total-rows="totalRow" :per-page="page_limit"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  isEmpty, upperFirst, difference, isMatch,
} from 'lodash';
import moment from 'moment';
import humanizeDuration from 'humanize-duration';
import reportApi from '../../../api/reports';
import popupErrorMessages from '../../../library/popup-error-messages';
import customFeatures from '../../../api/customFeatures';

export default {
  beforeCreate() {
    this.moment = moment;
    this.humanizeDuration = humanizeDuration;
  },
  name: 'CallReports',
  metaInfo: {
    title: 'Call Reports',
  },
  data() {
    return {
      upperFirst,
      page_limit: 50,
      loading: {
        table: false,
        custom_feature: false,
      },
      callType: this.$route.query.direction_filter || '',
      callChannel: this.$route.query.channel_type || '',
      status_filter: this.$route.query.status_filter || '',
      statusFilterOptions: [
        {
          value: '',
          text: 'All Status',
        },
        {
          value: 'calling', // ringing, answered
          text: 'Progress',
        },
        {
          value: 'answered', // completed
          text: 'Completed',
        },
        {
          value: 'no_answer', // others
          text: 'Failed',
        },
      ],
      callTypeOptions: [
        {
          value: '',
          text: 'All Type',
        },
        {
          value: 'incoming',
          text: 'Incoming',
        },
        {
          value: 'outgoing',
          text: 'Outgoing',
        },
      ],
      callChannelOptions: [
        {
          value: '',
          text: 'All Channel',
        },
        {
          value: 'whatsapp',
          text: 'WhatsApp',
        },
        {
          value: 'phone_call',
          text: 'VoIP Call',
        },
      ],
      reportList: [],
      loaderStack: 0,
      loader: null,
      search: {
        date_range: [
          this.$route.query.start_date || new Date(),
          this.$route.query.end_date || new Date(),
        ],
      },
      page: this.$route.query.page || 1,
      totalRow: 0,
      date_picker_options: {
        disabledDate: (time) => {
          const today = moment();
          const diff = today.diff(moment(time), 'd');
          if (diff > 90 || diff < 0) {
            return true;
          }
          if (diff === 0) {
            if (today.isSame(moment(time), 'd') === false) {
              return true;
            }
          }
          return false;
        },
        shortcuts: [
          {
            text: 'This week',
            onClick(picker) {
              const start = moment().startOf('week').format();
              const end = moment().format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'This month',
            onClick(picker) {
              const start = moment().startOf('month').format();
              const end = moment().format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last week',
            onClick(picker) {
              const start = moment().subtract(1, 'week').startOf('week').format();
              const end = moment().subtract(1, 'week').endOf('week').format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last month',
            onClick(picker) {
              const start = moment().subtract(1, 'month').startOf('month').format();
              const end = moment().subtract(1, 'month').endOf('month').format();
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      custom_feature: {},
    };
  },
  computed: {
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace;
    },
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.page = val;
        this.getList();
      },
    },
  },
  async mounted() {
    this.showLoader();
    await this.getList();
    await this.getCustomFeature();
    this.hideLoader();
  },
  methods: {
    space(str) {
      return str.replace(/_/gi, ' ');
    },
    ucwords(str) {
      /* eslint-disable no-plusplus */
      const words = this.space(str).split(' ');
      for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
      }
      return words.join(' ');
    },
    dateCheck() {
      const [start_date, end_date] = this.search.date_range;
      const minTime = moment(start_date);
      const maxTime = moment(end_date);
      const diff = maxTime.diff(moment(minTime), 'd');
      if (diff > 30) {
        this.$message({
          title: this.$t('general.error.general'),
          type: 'warning',
          message: 'Reporting period that can be selected for 31 days',
          duration: 20 * 100,
          showClose: true,
        });
        this.search.date_range = [start_date, start_date];
      }
    },
    countDuration(start, end) {
      console.log(moment(start).diff(moment(end), 'second'), start, end);
      return start && end ? humanizeDuration(moment(start).diff(moment(end), 'second'), { largest: 2, round: true }) : '-';
    },
    formatDate(string, format = 'DD MMM YYYY, HH:mm:ss') {
      return string ? moment(string).format(format) : '-';
    },
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
    async downloadReport() {
      this.$confirm(this.$t('report.confirm_download'), this.$t('general.confirmation'), {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        /* eslint-disable no-param-reassign */
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            // this.loading.table = true;
            if (isEmpty(this.search.date_range)) {
              this.search.date_range = [new Date(), new Date()];
            }
            const [start_date, end_date] = this.search.date_range;
            const response = await reportApi.downloadCallList({
              workspace_id: this.activeWorkspace._id,
              start_date: this.formatDate(start_date, 'YYYY-MM-DD'),
              end_date: this.formatDate(end_date, 'YYYY-MM-DD'),
              call_type: this.callType,
              channel_type: this.callChannel,
              status_filter: this.status_filter,
            }).catch(() => {});
            // this.loading.table = false;
            instance.confirmButtonLoading = false;
            await popupErrorMessages(response);
            this.$message({
              title: this.$t('general.success'),
              type: 'success',
              message: this.$t('general.waiting_download'),
              duration: 30 * 1000,
              showClose: true,
            });
          }
          cb();
        },
      });
    },
    async getList() {
      if (isEmpty(this.search.date_range)) {
        this.search.date_range = [new Date(), new Date()];
      }
      this.dateCheck();
      const [start_date, end_date] = this.search.date_range;
      const options = {
        page: this.page,
        start_date: this.formatDate(start_date, 'YYYY-MM-DD'),
        end_date: this.formatDate(end_date, 'YYYY-MM-DD'),
        direction_filter: this.callType,
        channel_type: this.callChannel,
        status_filter: this.status_filter,
      };
      if (!isMatch(this.$route.query, options)) {
        this.$router.replace({ query: options });
        return;
      }
      this.loading.table = true;
      const response = await reportApi.callList({
        workspace_id: this.activeWorkspace._id,
        ...options,
      }).catch(() => {});
      this.loading.table = false;
      await popupErrorMessages(response);
      this.reportList = response.data.rows.map((item) => {
        item.status_str = 'Failed';
        item.status_color = 'danger';
        if (item.duration && ['completed', 'answered'].includes(item.status)) {
          item.status_str = 'Success';
          item.status_color = 'success';
        } else if (item.duration && ['forward_answered'].includes(item.status)) {
          item.status_str = 'Forward Success';
          item.status_color = 'success';
        } else if (['forward_no_answer'].includes(item.status)) {
          item.status_str = 'Forward Failed';
          item.status_color = 'danger';
        } else if (['ringing', 'answered'].includes(item.status)) {
          item.status_str = 'Progress';
          item.status_color = 'info';
          if (item.status === 'answered' && item.rejected_by_user) {
            item.status_str = 'Rejected';
            item.status_color = 'danger';
          }
          if (item.status === 'answered' && item.terminated_at && item.answered_at) {
            item.status_str = 'Success';
            item.status_color = 'success';
          }
        } else {
          if (item.channel_type === 'phone_call' && item.direction.toLowerCase() === 'incoming' && item.status.toLowerCase() === 'rejected') {
            if (item.rejected_by_user) {
              item.status_str = 'Rejected';
            } else {
              item.status_str = 'Canceled';
            }
          }
          //  else {
          //   item.status_str = this.ucwords(item.status);
          // }
          item.status_str = this.ucwords(item.status);
          item.status_color = 'danger';
        }
        if (item.rejected_by_user?.id) {
          item.agent = item.rejected_by_user;
        } else if (item.accepted_by_user?.id) {
          item.agent = item.accepted_by_user;
        }
        if (item.direction) {
          item.type_str = upperFirst(item.direction);
        }
        item.action_type_str = 'Voice call';
        if (item.channel_type === 'whatsapp') {
          if (item.msg_whatsapp?.call_session?.action_type === 'video_call') {
            item.action_type_str = 'Video call';
          }
        }
        // if (item.ringing_at) {
        //   item.ring_duration = item.answered_at ? moment(item.answered_at || item.rejected_at || item.terminated_at).diff(moment(item.ringing_at || item.created_at), 'second') : '';
        // } else {

        // }
        if (item.answered_at && item.answered_at !== item.ringing_at) {
          console.log(item);
        }
        item.ring_duration = item.answered_at && item.duration ? moment(item.answered_at || item.rejected_at || item.terminated_at).diff(moment(item.ringing_at || item.created_at), 'second') : '';
        return item;
      });
      this.totalRow = response.data.count;
    },
    handleInputStatusFilter(value) {
      if (value[value.length - 1] === 'all') {
        this.status_filter = ['all'];
      } else if (value.indexOf('all') !== -1) {
        this.status_filter.splice(value.indexOf('all'), 1);
      } else if (difference(['calling', 'ended', 'failed'], this.status_filter).length === 0) {
        this.status_filter = ['all'];
      }
    },
    getRecordingLink(item) {
      if (item?.msg_voip?.call_session?.recording_link?.includes('http')) {
        return item.msg_voip.call_session.recording_link;
      }

      if (item?.msg_whatsapp?.call_session?.recording_link?.includes('http')) {
        return item.msg_whatsapp.call_session.recording_link;
      }

      if (item?.msg_whatsapp?.body?.includes('http')) {
        return item.msg_whatsapp.body;
      }

      return null;
    },
    async getCustomFeature() {
      this.loading.custom_feature = true;
      const response = await customFeatures.getCustomFeature(this.activeWorkspace._id);
      this.loading.custom_feature = false;
      await popupErrorMessages(response);
      this.custom_feature = response.data;
    },
    getSlaTimeResponseDeadline(channel_type, time, sla_time, terminated_at, duration) {
      if (terminated_at && duration) {
        if (time && channel_type === 'phone_call') {
          return moment(time)
            .add(parseInt(sla_time), 'seconds')
            .format('DD MMM YYYY, HH:mm:ss');
        }
        return moment(terminated_at)
          .subtract(duration, 'seconds')
          .add(parseInt(sla_time), 'seconds')
          .format('DD MMM YYYY, HH:mm:ss');
      }
      return moment(time)
        .add(parseInt(sla_time), 'seconds')
        .format('DD MMM YYYY, HH:mm:ss');
    },
    validationStatusSla(time, sla_time) {
      return time > sla_time;
    },
    isOverdueFirstTimeResponse(item, firstTimeResponse) {
      const ringingOrCreated = item.ringing_at || item.created_at;
      const answered = item.answered_at;
      const diffInMinutes = moment(answered).milliseconds(0).diff(moment(ringingOrCreated).milliseconds(0), 'seconds', true);
      return this.validationStatusSla(diffInMinutes, firstTimeResponse);
    },
    isOverdueResolutionTime(item, resolutionTime) {
      let answeredAt;
      if (item.answered_at && item.channel_type === 'phone_call') {
        answeredAt = item.answered_at;
      } else {
        answeredAt = moment(item.terminated_at).subtract(item.duration, 'seconds');
      }
      const diffInSeconds = moment(item.terminated_at || moment())
        .milliseconds(0)
        .diff(moment(answeredAt).milliseconds(0), 'seconds', true);
      return this.validationStatusSla(diffInSeconds, resolutionTime);
    },
    formatAnsweredTime(item) {
      if ((!item.terminated_at && !item.answered_at) || !item.duration) {
        return '-';
      }
      if (item.answered_at && item.duration && item.channel_type === 'phone_call') {
        return this.formatDate(item.answered_at);
      }
      return this.formatDate(moment(item.terminated_at).subtract(item.duration, 'seconds'));
    },
    formatDuration(item) {
      if (!item.answered_at || !item.duration) return '-';
      if (item.answered_at && item.duration && item.channel_type === 'phone_call') {
        return humanizeDuration(moment(item.terminated_at).milliseconds(0).diff(moment(item.answered_at).milliseconds(0), 'seconds', true) * 1000);
      }
      return humanizeDuration(item.duration * 1000);
    },
    isChatPrivacy(phone_number) {
      if (this.$store.state.auth.userProfile.is_pic !== true && this.$store.state.auth.userProfile.agents && this.$store.state.auth.userProfile.agents[0] && this.activeWorkspace.configuration && this.activeWorkspace.configuration.chat_privasi && this.activeWorkspace.configuration.chat_privasi.masking_phone_number === true) {
        if (phone_number && this.validatePhoneNumber(phone_number)) {
          return `${phone_number.substring(0, 2)}********${phone_number.substring(phone_number.length - 2)}`;
        }
      }
      return phone_number;
    },
    validatePhoneNumber(phone_number) {
      const validateRegex = /^\+?[1-9][0-9]{7,14}$/;
      return validateRegex.test(`+${phone_number}`);
    },
    // checkPrivacy(item) {
    //   let str = item.identifier;
    //   if (['Forward Success', 'Forward Failed', 'Success'].includes(item.status_str) && item.direction === 'incoming') {
    //     str = this.isChatPrivacy(item.identifier);
    //   }
    //   return str;
    // },
  },
};
</script>
